import React from 'react';
import './Breadcrumb.css';

export interface WxbBreadcrumbItem {
  key?: React.Key;
  label: React.ReactNode;
  href?: string;
  onClick?: () => void;
}

export interface WxbBreadcrumbProps extends React.HTMLAttributes<HTMLElement> {
  items: WxbBreadcrumbItem[];
  separator?: React.ReactNode;
}

export const WxbBreadcrumb: React.FC<WxbBreadcrumbProps> = ({
  items,
  separator = '/',
  className = '',
  'aria-label': ariaLabel = '面包屑',
  ...props
}) => (
  <nav
    {...props}
    className={`wxb-breadcrumb ${className}`}
    aria-label={ariaLabel}
  >
    <ol className="wxb-breadcrumb-list">
      {items.map((item, index) => {
        const isCurrent = index === items.length - 1;
        const key = item.key ?? index;

        return (
          <li key={key} className="wxb-breadcrumb-item">
            {index > 0 && (
              <span className="wxb-breadcrumb-sep" aria-hidden="true">{separator}</span>
            )}
            {isCurrent ? (
              <span className="wxb-breadcrumb-current" aria-current="page">{item.label}</span>
            ) : item.href ? (
              <a
                className="wxb-breadcrumb-link"
                href={item.href}
                onClick={(event) => {
                  if (!item.onClick) return;
                  event.preventDefault();
                  item.onClick();
                }}
              >
                {item.label}
              </a>
            ) : item.onClick ? (
              <button type="button" className="wxb-breadcrumb-link" onClick={item.onClick}>
                {item.label}
              </button>
            ) : (
              <span className="wxb-breadcrumb-label">{item.label}</span>
            )}
          </li>
        );
      })}
    </ol>
  </nav>
);
